import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function PositionedSnackbar(props) {
  const { setAlertstate } = props;
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const [state, setState] = React.useState({ open: true });

  const { open } = state;
  const anchorOrigin = isSmall
    ? { vertical: 'top', horizontal: 'center' }
    : { vertical: 'bottom', horizontal: 'right' };
  const handleClose = () => {
    setState({ ...state, open: false });
    setAlertstate(false);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={anchorOrigin}
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        sx={{
          width: { xs: 'calc(100% - 24px)', sm: 'auto' },
          left: { xs: '12px !important', sm: 'auto' },
          right: { xs: '12px !important', sm: '16px' },
        }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          sx={{
            backgroundColor: '#523370',
            width: '100%',
            maxWidth: { xs: '100%', sm: 420 },
            typography: { xs: 'body2', sm: 'body1' },
            wordBreak: 'break-word',
          }}
          severity="info"
        >
          Machines limit exceeded!
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
